import { styled } from 'styled-components';

import { RichDetails } from '#/components/RichDetails/RichDetails';
import { detailsOneWhenClosedMinusOneWhenOpenVar } from '#/components/RichDetails/richDetailsCssVariables';
import { colors, cssBreakpoints, spacing } from '#/theme/theme';

export const OrgListingsTabsMobile = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const OrgListingsTabsMobileDetails = styled(RichDetails)`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${colors.calloutGrey};
  ${detailsOneWhenClosedMinusOneWhenOpenVar}: 1;

  &[open] {
    ${detailsOneWhenClosedMinusOneWhenOpenVar}: -1;

    > summary {
      color: ${colors.brandBlue};
    }

    .tab-icon {
      background-color: ${colors.brandBlue};
    }
  }
`;

export const OrgListingsTabsMobileSummary = styled.summary`
  list-style: '';
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: ${spacing[24]};
  padding-top: ${spacing[8]};
  padding-bottom: ${spacing[8]};

  &::-webkit-details-marker /* Safari < 18.4 */ {
    display: none;
  }
`;

export const OrgListingsTabsDesktop = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
